module.exports = __webpack_public_path__ + "static/media/20ECE20.7af6c06a.jpg";